import { Box, SxProps } from '@mui/material';
import { FC } from 'react';

export interface LabeledSectionProps {
  label: string;
  labelPlaceholder?: React.ReactNode;
  sx?: SxProps;
  children?: React.ReactNode;
}

export const LabeledSection: FC<LabeledSectionProps> = (props) => {
  const { label, sx, labelPlaceholder, children } = props;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', margin: '20px 20px 0 20px', paddingLeft: '5px', ...sx }}>
      <Box
        sx={{
          color: 'black',
          fontSize: '14px',
          lineHeight: '160%',
          fontWeight: 600,
          borderBottom: 'solid 1px #E9EAEE',
          paddingBottom: '5px',
          alignItems: 'center',
          justifyContent: 'space-between',
          display: 'flex'
        }}
      >
        {label}
        {labelPlaceholder}
      </Box>
      <Box sx={{ lineHeight: '140%', letterSpacing: '0.15px', fontSize: '12px', margin: '10px 5px 5px 5px' }}>
        {children}
      </Box>
    </Box>
  );
};
